import * as actionTypes from '../actions/actionTypes';

export const assetCashManagerInitialState = {
  cashManager: {},
  loading: false,
  loaded: false,
  error: null
};

const reducer = (state = assetCashManagerInitialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ASSET_CASH_MANAGER_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_ASSET_CASH_MANAGER_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        cashManager: action.cashManager
      };
    case actionTypes.GET_ASSET_CASH_MANAGER_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
